import * as React from 'react';

import { SeparatorLineBase } from '@packages/ui';
import { NewsletterFooterContainer } from '@packages/shared';
import { TLD } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { Title } from './Title';
import { FooterLinksProps, FooterLinks } from './links/FooterLinks';
import { Copyright } from './Copyright';

export interface FooterProps {
  links: FooterLinksProps;
  title: string;
  copyrightText: string;
}

const APP_TLD = getPublicRuntimeConfig('APP_TLD');

export const Footer: React.FC<FooterProps> = ({ links, title, copyrightText }) => {
  //TODO Enable Newsletter in NL again when we roll out this feature
  return (
    <footer>
      {APP_TLD !== TLD.NL ? <NewsletterFooterContainer tag="footer" /> : null}
      <SeparatorLineBase />
      <Title title={title} />
      <SeparatorLineBase />
      <FooterLinks {...links} />
      <Copyright text={copyrightText} />
    </footer>
  );
};
